export enum FormType {
  Registration = 0,
  Submission = 1,
  Review = 2,
  PaymentGatewayConnection = 3,
  Custom = 4,
}
